import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/24_card_back_butterfly/24_card_back_butterfly"
 * Contains 1 texture(s)
 */
export class CardsBacks24CardBackButterflyAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/24_card_back_butterfly/24_card_back_butterfly';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '24_butterfly.png'
    ] as const;
}
